import React from "react";
import ModalLayout from "../..";
import "./style.scss";
import TagComp from "../../../tag";
import { RightArrowIcon, TicketMergedIcon } from "../../../../icons";

interface MergedTicketsProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onConfirm: () => void;
  data?: any[];
  onSwitchToMerged: () => void;
}

interface Ticket {
  id: string;
  title: string;
  type: string;
  category: string;
  location: string;
}

// const mergedTickets: Ticket[] = [
//   {
//     id: "#863765",
//     title: "Animal Dead",
//     type: "Incident",
//     category: "Dead animal removal",
//     location: "12 Rosewood Drive, Sandton",
//   },
//   {
//     id: "#563765",
//     title: "Animal Dead",
//     type: "Incident",
//     category: "Dead animal removal",
//     location: "12 Rosewood Drive, Sandton",
//   },
// ];

const MergedTickets: React.FC<MergedTicketsProps> = ({
  open,
  onClose,
  onConfirm,
  title = "heading test",
  onSwitchToMerged,
  data: mergedTickets = [],
}) => {
  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      secondaryBtnText=""
      closeBtnText=""
    >
      <div className="merged-tickets-wrapper">
        {mergedTickets.map((ticket) => (
          <div
            key={ticket.id}
            onClick={onSwitchToMerged}
            className="ticket-card border-b border-gray-200 pb-3 last:border-none flex flex-col gap-2"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 w-full justify-between">
                <span className="ticket-id text-sm text-gray-500">
                  {ticket.call_type}
                </span>
                <span className="arrow-icon">
                  <RightArrowIcon />
                </span>
              </div>
              {/* <ChevronRightIcon /> */}
            </div>

            <div className="flex gap-4 items-center">
              <h4 className="ticket-title font-medium">
                {ticket.service_ticket_no}
              </h4>
              <TicketMergedIcon />
            </div>

            <div className="flex flex-wrap gap-2">
              <TagComp className="ant-tag-ticket">{ticket.catgeory}</TagComp>
              <TagComp className="ant-tag-ticket">{ticket.call_type}</TagComp>
              <TagComp className="ant-tag-ticket">
                {ticket.service_address_info}
              </TagComp>
            </div>
          </div>
        ))}
      </div>
    </ModalLayout>
  );
};

export default MergedTickets;
